<div class="" *ngIf="isShow || isAdminShow">
  <!-- tabs-to-dropdown -->
 
    <button class="navbar-toggler subnav-toggler d-lg-none" type="button" (click)="toggleMenu()"
      [attr.aria-expanded]="isMenuOpen" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse custom-nav-collapse " [class.show]="isMenuOpen">
      <ng-container *ngIf="isShow">
       <div class="tabs-to-dropdown-customer-navbar">
        <div class="nav-wrapper-custom">
        <ul class="nav nav-pills custom-nav-list" role="tablist">
          <li class="nav-item" role="presentation">
            <a class="nav-link" routerLink="/customer/dashboard" routerLinkActive="active" (click)="closeMenu()">Dashboard</a>
          </li>
          <li class="nav-item" role="presentation">
            <a class="nav-link" routerLink="/customer/order-file" routerLinkActive="active" (click)="closeMenu()">Order File</a>
          </li>
          <li class="nav-item" role="presentation">
            <a class="nav-link" routerLink="/customer/orders" routerLinkActive="active" (click)="closeMenu()">Orders</a>
          </li>
          <li class="nav-item" role="presentation">
            <a class="nav-link" routerLink="/customer/tracking-api" routerLinkActive="active" (click)="closeMenu()">Tracking API</a>
          </li>
          <li class="nav-item" role="presentation">
            <a class="nav-link" routerLink="/authorization" routerLinkActive="active" (click)="closeMenu()">Amazon Auth</a>
          </li>
        </ul>
      </div>
    </div>
      </ng-container>

      <ng-container *ngIf="isAdminShow">
        <div class="tabs-to-dropdown">
          <div class="nav-wrapper">
        <ul class="nav nav-pills custom-nav-list" role="tablist">
          <li class="nav-item" role="presentation">
            <a class="nav-link" routerLink="/admin/dashboard" routerLinkActive="active" (click)="closeMenu()">Dashboard</a>
          </li>
          <li class="nav-item" role="presentation">
            <a class="nav-link" routerLink="/admin/orders-file" routerLinkActive="active" (click)="closeMenu()">Order File</a>
          </li>
          <li class="nav-item" role="presentation">
            <a routerLink="/admin/orders" class="nav-link" routerLinkActive="active" (click)="closeMenu()">Orders</a>
          </li>
          <li class="nav-item" role="presentation">
            <a class="nav-link" routerLink="/admin/contact-list" routerLinkActive="active" (click)="closeMenu()">Contact List</a>
          </li>
          <li class="nav-item" role="presentation">
            <a routerLink="/admin/subscription-plan" class="nav-link" routerLinkActive="active" (click)="closeMenu()">Subscription Plan</a>
          </li>
          <li class="nav-item" role="presentation">
            <a routerLink="/admin/customer-details" class="nav-link" routerLinkActive="active" (click)="closeMenu()">Customer Details</a>
          </li>
          <li class="nav-item nav-item1 nav-item--dropdown" [class.dropdown-open]="isDropdownOpen('settings')">
            <button type="button" class="nav-link nav-dropdown-toggle"
              [class.dropdown-toggle-open]="isDropdownOpen('settings')"
              [attr.aria-expanded]="isDropdownOpen('settings')"
              (click)="toggleDropdown('settings', $event)">
              <span>General Settings</span>
              <i class='bx bx-chevron-down'></i>
            </button>
            <ul class="dropdown-menu" [class.show]="isDropdownOpen('settings')">
              <li class="nav-item1">
                <a routerLink="/admin/carrier-company-configuration" routerLinkActive="active" class="nav-link"
                  (click)="closeMenu()">Carrier Company Configuration</a>
              </li>
              <li class="nav-item1">
                <a routerLink="/admin/email-configuration" class="nav-link" routerLinkActive="active"
                  (click)="closeMenu()">Email Configuration</a>
              </li>
              <li class="nav-item1">
                <a routerLink="/admin/master-data" class="nav-link" routerLinkActive="active"
                  (click)="closeMenu()">Site Configuration</a>
              </li>
              <li class="nav-item1" role="presentation">
                <a class="nav-link" routerLink="/admin/marketplace-flow" routerLinkActive="active"
                  (click)="closeMenu()">Marketplace Flow</a>
              </li>
              <li class="nav-item1" role="presentation">
                <a class="nav-link" routerLink="/admin/shipment-status" routerLinkActive="active"
                  (click)="closeMenu()">Shipment Status</a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
        </div>
      </ng-container>
    </div>
  </div>

